// import {message} from 'ant-design-vue'
import Home from './home.vue'

export default [{
    path: '/home',
    name:'home',
    component:Home,
    // beforeEnter(to,from,next){
    //     message.config({top:'104px'});
    //     next()
    // },
    // beforeRouteLeave(to,from,next) {
    //     message.destroy();
    //     next()
    // }
},
{
    path: '',
    redirect: { name: 'home' }
}]